var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 120,
    viewBox: "0 0 122 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7860_19131)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.7374,
    cy: 60,
    rx: 60.7394,
    ry: 60,
    fill: "#EC9832",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.0676,
    cy: 60.3316,
    rx: 44.2961,
    ry: 43.7569,
    fill: "#EC9832",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9063 59.9998C76.9063 57.7081 78.7813 55.8331 81.0729 55.8331V47.4998C81.0729 45.2081 79.1979 43.3331 76.9063 43.3331H43.5729C41.2813 43.3331 39.4271 45.2081 39.4271 47.4998V55.8331C41.7188 55.8331 43.5729 57.7081 43.5729 59.9998C43.5729 62.2915 41.7188 64.1665 39.4062 64.1665V72.4998C39.4062 74.7915 41.2813 76.6665 43.5729 76.6665H76.9063C79.1979 76.6665 81.0729 74.7915 81.0729 72.4998V64.1665C78.7813 64.1665 76.9063 62.2915 76.9063 59.9998ZM67.6979 69.9998L60.2396 65.2081L52.7813 69.9998L55.0313 61.4165L48.1771 55.8123L57.0104 55.2915L60.2396 47.0831L63.4479 55.3123L72.2813 55.8331L65.4271 61.4373L67.6979 69.9998Z",
    fill: "#EC9832"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7860_19131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121.479,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceUpdate);
export default __webpack_public_path__ + "static/media/price-update.68617b2bbeb75906c000802bbd6295dc.svg";
export { ForwardRef as ReactComponent };